export default {
  tip1: "1. 当前显示为自己下单（非现场缴费）包含押金并且可以申请的订单",
  tip2_prev: "2. 可申请的订单需同时满足以下几个条件",
  tip2: "未申请过、已到押金退还申请时间;",
  tip3:
    "3. 如已满足第二点所有条件且不再已申请押金之列，仍无法申请押金请咨询工作人员",
  exhibition: "展会",
  exhibition_placeholder: "请输入展会名称",
  remit_code: "付款识别码",
  remit_code_placeholder: "请输入付款识别码，回车查询",
  remit_code_tip: "如果您是现场通过现金/刷卡缴费的，请通过付款识别码查询",
  foregit_tab: "押金申请",
  orderNum_label: "支付识别码",
  payway_label: "支付方式",
  exhibitor: "参展商",
  exnum: "展位",
  foregift_name: "押金名称",
  amount: "金额",
  deduction: "扣费金额",
  deduction_name: "扣费押金",
  balance: "余额",
  deduction_detail: "查看扣费明细",
  total: "合计",
  apply: "申请",
  deduction_remark: "扣费说明",
  warn_tip: "温馨提示：点击支付码可查看押金和扣费明细",
  apply_record: "申请记录",
  modify: "修改",
  detail: "查看",
  cancel: "取消",
  check_code: "如何查看识别码",
  code_prop_1: "现场缴纳的费用会在我们给您的小票中位于",
  code_prop_2: "条形码下方",
  code_prop_3: "见图实例红色框内",
  foregift_detail: "详细信息",
  detail_header: "基本信息",
  cetification: "证明材料",
  name: "名称",
  upload: "上传资料",
  remark: "备注",
  info_remark: "资料说明",
  balance_tip: "申请金额",
  balance_unit: "元",
  request_num: "申请编号",
  order_num: "订单号",
  exnum_num: "展位号",
  request_time: "申请时间",
  request_status: "申请状态",
  operation: "操作",
  cancel_title: "取消该押金申请",
  cancel_content: "您是否确定要取消该押金申请？",
  cancel_ok: "是",
  cancel_deny: "否",
  // 押金申请
  apply_title: "押金退回申请服务",
  status: "状态",
  channel: "退款渠道",
  account_type: "银行卡账户类型",
  account_info: "对公账户指您的公司账户，对私账户为您的私人账户",
  account_type_placeholder: "请填写您的银行卡账户类型",
  card_type: "银行卡类型",
  card_type_placeholder: "请填写银行卡类型",
  bank_name: "银行支行名称",
  bank_name_placeholder: "如:中国银行深圳民治支行",
  bank_account: "银行账号",
  bank_account_placeholder: "请填写银行账号",
  bank_account_name: "银行账户名",
  bank_account_name_placeholder: "请填写您的银行账户名",
  city: "所在城市",
  city_placeholder: "请填写所在城市",
  province: "所在省份",
  province_placeholder: "请填写所在省份",
  remarks: "申请说明",
  remarks_placeholder: "请填写申请说明",
  please_upload: "请上传以下证明材料",
  return_list: "返回押金申请列表",
  commit: "提交",
  fee_detail: "押金详情",
  can_balance: "可退押金余额为",
  back: "返回",
  upload_btn: "上传",
  del_image_content: "是否确定删除图片",
  del_title: "删除图片确认",
  del_success: "图片删除成功",
  del_fail: "图片删除失败",
  notice: "注意",
  no_foregift: "当前暂无押金证明材料信息",
  no_apply: "未申请",
  need_confirm: "待确认",
  wait_refund: "待退款",
  tomake: "待制单",
  refund: "已退款",
  accepted: "银行已受理",
  rejected: "未通过",
  wait_review: "待审核",
  cancelled: "已取消",
  finished: "已处理",
  refund_fail: "退款失败",
  upload_button: "请选择图片",
  warm_tip_1: "温馨提示：申请退押金未通过在修改时发现押金",
  warm_tip_2: "与上次提交押金",
  warm_tip_3: "不符合时请查看返回押金申请列表查看扣费情况或咨询项目部。",
  public_account: "对公账户",
  private_account: "对私账户",
  privacy: "对私账户",
  debit: "借记卡",
  save: "储蓄卡",
  wechat: "微信退款",
  alipay: "支付宝退款",
  net: "网银退款",
  scene: "现场退款",
  public_way: "公账退款",
  CLOUDBILL: "云账单退款",
  pay_online: "网银支付",
  pay_cash: "现金刷卡",
  pay_balance: "余额支付",
  pay_remit: "转账汇款",
  pay_mini_wechat: "小程序微信支付",
  pay_wechat_scan: "微信扫码支付",
  pay_alipay_scan: "支付宝扫码支付",
  pay_alipay_h5: "支付宝H5支付",
  pay_wechat_h5: "微信H5支付",
  pay_cloud: "云账单支付",
  pay_wechat: "微信支付",
  pay_alipay: "支付宝支付",
  audit_opinion: "审核意见",
  如您有特殊情况备注: "如您有特殊情况，请备注",
  暂无扣费信息: "暂无扣费信息",

  "预授权30天内自动解冻，预授权金额：": "预授权30天内自动解冻，预授权金额：",
  元: "元"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/foregift.js